import { InjectionToken } from '@angular/core';
import type { TranslationResource } from 'ngx-translate-multi-http-loader';

export const ONYX_TRANSLATIONS_SOURCE: TranslationResource = {
  prefix: 'i18n/onyx-angular/',
  suffix: '.json',
};

export const ONYX_HERE_MAPS_API_KEY = new InjectionToken<string>(
  'HERE Maps API Key',
);

export const ONYX_INPUT_DEBOUNCE_TIME = 600;
export const ONYX_LAYOUT_DEBOUNCE_TIME = 100;

export const ONYX_TABLE_TOOLTIP_DELAY = 250;
export const ONYX_TOOLTIP_DELAY = 500;
export const ONYX_TOOLTIP_SKIP_DELAY_DURATION = 300;

export const ONYX_TRANSITION_DURATION = 250;
